import { useCallback } from "react";
import * as Styled from "./style";

import { isOpenReviewModalVar } from "~/components/stores/detail-product/store";
import { openDialog } from "~/components/stores/dialog/store";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { useMatchMedia } from "~/hooks/use-match-media";
import { useAuth } from "~/provider/auth";

/** レビューが1件もない場合に表示するコンポーネント */
export const NoReview = () => {
  const { isLoggedIn, execAuth } = useAuth();

  const { handleClickByDevice } = useHandleClickByDevice();
  const { isSpSize } = useMatchMedia();

  const handleReviewBtnPressed = useCallback(() => {
    if (!isLoggedIn) {
      openDialog({
        title: "レビュー投稿/編集は\nログイン後にできます",
        description: "ログインしますか？",
        mainButtonName: "ログイン",
        mainButtonLabelText: "ログイン",
        isDisabledAnimation: true,
        onMainButtonAction: execAuth,
      });

      return;
    }

    isOpenReviewModalVar(true);
  }, [isLoggedIn]);

  return (
    <Styled.DivNoReviewRoot>
      <Styled.DivTextWrapper>
        <p>この作品に最初のレビューを書いてみませんか？</p>
        <p>他のユーザーにあなたの感想を伝えましょう</p>
      </Styled.DivTextWrapper>

      <Styled.Button
        name="post-review"
        mainText="レビュー投稿 / 編集"
        color="GRAY900"
        fontSize={isSpSize ? "S" : "M"}
        {...handleClickByDevice(handleReviewBtnPressed)}
      />
    </Styled.DivNoReviewRoot>
  );
};
